<div class="form-row">
	<mat-form-field appearance="outline" class="search-place w-100">
		<input
			#searchTextField
			matInput
			[(ngModel)]="address"
			type="text"
			placeholder="Search address or insert geographic coordinates (N. XX.XXXX, E. YY.YYYY)"
			(ngModelChange)="onInputChange($event)"
			(keyup.enter)="checkCoordinates()"
		/>
		<span *ngIf="showCoordinatesSwitch" class="toggle-coordinates">
			<span class="text-lightgrey" [class.active-option]="activeCoordinates === 'wgs84'">WGS84</span>
			<mat-slide-toggle
				disableRipple
				class="mx-2 mat-checked"
				(change)="onChangeToggle($event)"
			></mat-slide-toggle>
			<span class="text-lightgrey" [class.active-option]="activeCoordinates === 'ed50'">ED50</span>
		</span>
	</mat-form-field>
</div>
